<template>
    <div id="start_today_card" class="">
        <div class="p-lg-5 p-md-5 p-sm-2">
            <!-- <h4 class="mb-2">Comienza tu solicitud hoy mismo.</h4> -->
            <div class="axil-contact-form">
                <div class="form-group">
                    <div class="mb--10">
                        <label class="form-label bold">Nombre</label>
                        <input v-model.trim="model.name" type="text" class="form-control" name="contact-name"
                            :placeholder="nameHolder">
                    </div>
                    <div class="mb--10">
                        <label class="form-label bold">Télefono</label>
                        <input v-model.trim="model.phone" type="tel" class="form-control" name="contact-email"
                            placeholder="+52 1234567890">
                    </div>
                    <div class="mb-5">
                        <label class="form-label bold">Correo</label>
                        <input v-model.trim="model.email" type="email" class="form-control" name="contact-email"
                            :placeholder="emailHolder">
                    </div>

                    <!-- <div class="flex">
                        <input v-model="model.rg_contact" type="checkbox" value="1" class="rg-checkbox">
                        <p class="mb-3 text-justify">
                            Quiero que me contacte un asesor vía correo electrónico o teléfono.
                        </p>
                    </div> -->
                    <div class="flex mb--30">
                        <input v-model="model.legal" type="checkbox" value="" class="rg-checkbox">
                        <p class="text-justify">Acepto los términos, condiciones y el Aviso de Privacidad para los clientes y prospectos. Estoy de acuerdo con que RedGirasol me contacte por correo o teléfono.</p>
                    </div>
                    <!-- <div class="row justify-content-center mb-0">
                        <div class="col-12 btn-center">
                            <button 
                                @click.stop="showResults()"
                                class="axil-btn rg-btn-dark rg-style-button mb-4" 
                                type="border">
                                Ver resultados
                            </button>
                            <h6 @click.stop="resetSimulation()" class="mb-0 clickable">Iniciar otra simulación</h6>
                        </div>
                    </div> -->
                </div>
                <!-- CAPTCHA -->
                <div class="col-md-12 mb--30 captcha-center ">
                    <vue-recaptcha v-show="showCaptcha" v-if="recaptchaSiteKey" ref="vrecaptcha" @verify="onVerify"
                        @expired="onExpired" :sitekey="recaptchaSiteKey"></vue-recaptcha>

                        <div v-if="errorMssg" class="alert alert-danger mt-4" role="alert">
                            {{ errorMssg }}
                        </div>

                        <div v-if="onSuccess" class="alert alert-success" role="alert">
                           {{ successText }}
                        </div>
                </div>

                <!-- BOTONES -->
                <div class="row justify-content-center mb-0 mt-5">
                    <div class="col-12 btn-center">
                        <button 
                            :class="{ disabled: isBusy }" 
                            @click.stop="sendForm()"
                            class="axil-btn rg-btn-dark rg-style-button mb-4" 
                            type="border">
                            Ver resultados
                        </button>
                        <h6 @click.stop="resetSimulation()" class="mb-0 clickable">Iniciar otra simulación</h6>
                    </div>
                </div>

                <!-- <div class="form-group">
                    <button :class="{ disabled: isBusy }" @click.stop="sendForm()"
                        class="axil-btn btn-borderd btn-fluid btn-primary rg-style-button " name="submit-btn">
                        <template v-if="!isBusy">Enviar</template>
                <template v-if="isBusy">Enviando...</template>
                </button>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
export default {
    name: "StartTodayCard",
    components: { VueRecaptcha },
    props: ["id", "urlPath", "nameHolder", "emailHolder", "originLanding", "lastEmail"],
    data() {
        return {
            model: {
                name: null,
                phone: null,
                email: null,
                recaptcha: null,
                legal: false,
                rg_contact: true
            },
            recaptcha: null,
            recaptchaSiteKey: null,
            errorMssg: null,
            onSuccess: false,
            completed: false,
            isBusy: false,
            successText: "¡Muchas gracias! En breve el equipo de RedGirasol se pondrá en contacto contigo.",
            supplierUrlBase: process.env.VUE_APP_REGISTER_SUPPLIER_URL
        }
    },
    async beforeMount() {
        this.recaptchaSiteKey = process.env.VUE_APP_RECPATCHA_SITE_KEY;
    },
    computed: {
        showCaptcha() {
            return (this.model.name != null && this.model.phone != null && this.model.email != null);
        }
    },
    mounted() {
        const rgCard = $('#start_today_card');
        // console.log(rgCard);
        $(window).on('scroll', function () {
            if ($(window).scrollTop() > 50) {
                rgCard.addClass('show');
            } else {
                rgCard.removeClass('show');
            }

        });
    },
    methods: {
        goToSupplierOnboarding() {
            window.open(`${this.supplierUrlBase}/?email=${this.email}`, "_blank");
        },
        validateCaptcha() {
            if (this.recaptcha == null) {
                this.errorMssg = "Por favor completa la verificación 'No soy un robot'."
                return false
            }
            return true
        },
        validateForm() {
            this.errorMssg = null;
            this.onSuccess = false;
            let valid = (!this.isEmpty(this.model.name) && !this.isEmpty(this.model.email) && this.model.phone !== null);
            if (!valid) {
                this.errorMssg = "Por favor completa completa todos los campos.";
                return false
            }
            // validacion de formato de correo
            let emailPattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
            if (!emailPattern.test(this.model.email)) {
                this.errorMssg = "Por favor ingresa un email válido 'ejemplo@mail.com'.";
                return false;
            }

            // Validar legales
            if(!this.model.legal) {
                this.errorMssg = "Es necesario que aceptes los términos, condiciones y el Aviso de Privacidad para los clientes y prospectos.";
                return false;
            }

            if (this.validateCaptcha()) {
                this.model.recaptcha = this.recaptcha;
                return true;
            }
            return false;
        },
        async sendForm() {
            if (this.isBusy) {
                return
            }

            if (this.validateForm()) {
                await this.doSendForm();
            }
        },
        async doSendForm() {
            this.isBusy = true
            try {
                const payload = {
                    lead: this.model,
                    origin: this.originLanding
                }
                if(this.lastEmail == null || this.lastEmail != this.model.email) {
                    await this.publicApiPost(`/api/v2/leads/${this.urlPath}`, payload);
                    this.lastEmail = this.model.email;
                }
                this.showResults();
                this.resetForm();
                this.onSuccess = true;
            }
            catch (e) {
                this.errorMssg = "Ha ocurrido un error, intenta más tarde."
            }
            this.isBusy = false
        },
        isEmpty(str) {
            return (str === null || str === undefined || !str.trim() || !str.trim().length);
        },
        resetForm() {
            this.errorMssg = null
            this.model = {}
            this.resetRecaptcha()
        },
        onVerify(response) {
            this.recaptcha = response;
        },
        onExpired() {
            this.recaptcha = null
        },
        resetRecaptcha() {
            this.recaptcha = null
            this.$refs.vrecaptcha.reset()
        },
        showResults() {
            this.$emit('updated', this.model.email, this.model.name);
        },
        resetSimulation() {
            this.$emit('reset');
        }
    }
}

</script>

<style scoped>
/* .form-floating {
    position: relative;
    top: 6rem;
} */

.start-card {
    position: fixed !important;
    position: absolute;
    bottom: 15rem;
    margin-right: 24rem;
    /* margin-left: -2rem;
    margin-right: 10rem; */
    z-index: 99;
    opacity: 0;
    -webkit-transform: scale(0.3);
    -ms-transform: scale(0.3);
    transform: scale(0.3);
    z-index: 9;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
}

.start-card.show {
    /* bottom: 40px;
        right: 40px; */
    opacity: 1;
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
}

.form-group {
    text-align-last: left;
}

.form-label {
    font-family: 'gilroyregular' !important;
}

.btn-center {
    text-align-last: center;
}

.captcha-center {
    text-align: -webkit-center;
}

@media only screen and (max-width: 575px) {
    /* .form-floating {
        top: 4rem !important;
    } */
}

@media only screen and (max-width: 991px) {
    .banner.banner-style-2 {
        top: 4rem !important;
    }
}
</style>